document.addEventListener(
  "king-linked-option-product-loaded",
  function (event) {
    console.log("Product options have been loaded and rendered.");
    const optionContainer = document.querySelector(
      ".page-content .lv-option-box[data-tpl='Weight'] .lv-option-group"
    );
    console.log("optionContainer", optionContainer);
    if (!optionContainer) {
      return;
    }
    const weightGuideOrigin = document.querySelector(
      ".weight_guide__standalone"
    );
    if (!weightGuideOrigin) {
      return;
    }
    optionContainer.appendChild(
      weightGuideOrigin.querySelector("tool-tip-trigger")
    );
  }
);
